module.exports = __webpack_public_path__ + "static/media/kids_playing_yellow.c49d92e9.png";